import React, { useState } from 'react';
import { useNavigate,Link } from 'react-router-dom';
import axios from 'axios';
import './LoginForm.css'; // Add any relevant CSS

// Served from frontend/public — reference by URL, not a src import.
const communityLogo = `${process.env.PUBLIC_URL}/logo512.png`;

const LoginForm = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ username: '', password: '' });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true); // Show loading state
        try {
            // Send POST request to login API          
            const response = await axios.post(`${API_BASE_URL}/api/login/`, formData);     
         
            // Check if response data contains token and role
            if (response.data.token && response.data.role) {
                // Save token and role to localStorage
                localStorage.setItem('token', response.data.token);  // Assuming the token is nested within the 'token' object
                localStorage.setItem('role', response.data.role);

                localStorage.setItem(
                    "Login_User_Community_Details",
                    JSON.stringify(response.data.token)
                );
                localStorage.setItem(
                    "Login_User_Community_All_Data",
                    JSON.stringify(response.data)
                  );
            
                // Navigate based on user role
                if (response.data.role === '1') {                   
                    navigate('/admin-user/admin-dashboard');
                } else if (response.data.role === '3') {
                    navigate('/provider-user/provider-dashboard');
                } else if (response.data.role === '2') {
                    navigate('/patient-user/patient-dashboard');
                } else if (response.data.role === '4') {
                    navigate('/vendor-user/vendor-dashboard');
                }else {
                    throw new Error('Unknown role');
                }
            } else {
                throw new Error('Missing token or role');
            }
        } catch (error) {
            console.error('Login failed:', error);

        // Set error message based on API response
        if (error.response && error.response.data && error.response.data.message) {
            setError(error.response.data.message); // Use the error message from the API
        } else {
            setError('Something went wrong. Please try again.'); // Fallback error message
        }
        } finally {
            setLoading(false); // Reset loading state
        }
    };

    return (
        <div className="login-form-container">
            <form className="login-form" onSubmit={handleSubmit}>
                <img
                    src={communityLogo}
                    alt="InspireEHR Community Board"
                    className="login-logo"
                />
                <h1>Login</h1>
                {error && <p className="error">{error}</p>}
                <div className="form-group">
                    <label>Username</label>
                    <input
                        type="text"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        disabled={loading} // Disable input during loading
                    />
                </div>
                <div className="form-group">
                    <label>Password</label>
                    <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                        disabled={loading} // Disable input during loading
                    />
                </div>
                <button className="btn primary" type="submit" disabled={loading}>
                    {loading ? 'Logging in...' : 'Login'}
                </button>
                <p className="register-link">
                    Don't have an account? <Link to="/register">Register here</Link>
                </p>
            </form>
        </div>
    );
};

export default LoginForm;
